import React, { Fragment, useEffect, useRef, useState } from 'react';

import {
  Validator,
} from 'devextreme-react/validator';
import {
    RequiredRule,
  } from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box'; 

import { useNavigate } from 'react-router-dom';
import { Button, SelectBox, TextBox } from 'devextreme-react';
import { useAuth } from '../../../auth-provider/auth-provider';
import { errorNotify } from '../../../../../shared/notifications';
import { mobileNumberValidation } from '../../../../../shared/dataValidation';
import { makeArrayUnique, removeEmptyMembersFromArray } from '../../../../../shared/array-functions';
import { persianLanguage } from '../../../../../constants/persianTerms';
import { iranianMobileRegex } from '../../../../../shared/regex-patterns';
import SpinnerLoading from '../../../../components/spinner-loading/SpinnerLoading';
import { convertPersianOrArabicNumbersToEnglishInTheString } from '../../../../../shared/numbers';

export default function LoginWithPassword(props){
    const auth = useAuth();
    const formRef = useRef(null);

    const navigate = useNavigate()

    const [mobileNumbers, setMobileNumbers] = useState(JSON.parse(localStorage.getItem('mobileNumbers')) || []);
    const [mobileNumber, setMobileNumber] = useState(null);
    
    const [mobile, setMobile] = useState(props.mobile);
    const [incorrectData, setIncorrectData] = useState(false);
    const [positionOf, setPositionOf] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [loginSetting, setLoginSetting] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    // Validation states
    const [isMobileValid, setIsMobileValid] = useState(false);
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [mobileValidationError, setMobileValidationError] = useState(null);
    const [passwordValidationError, setPasswordValidationError] = useState(null);

    const [formData, setFormData] = useState({
      "password": "",
      "mobile": "",
      "hashed": props?.authChallengeResult?.hashed,
      "salt": props?.authChallengeResult?.salt,
      "number": props?.authChallengeResult?.number,
    })

    const [uniqueArray, setUniqueArray] = useState(null);
    const [loginType, setLoginType] = useState(props?.loginType);
    
    useEffect(() => {
      if(auth?.token){
        navigate('/');
      }
      setLoginType(props?.loginType);
      if(mobileNumbers && mobileNumbers.length > 0){
        setMobileNumber(mobileNumbers[0])
      } else {
      }
     },[auth?.token]);

     function enableIsDisabled(){
      setTimeout(function(){ 
          setIsDisabled(false); 
      }, 2000);
    }

    // Validate mobile number function
    const validateMobileNumber = (number) => {
      if (!number || number.trim() === '') {
        setMobileValidationError('شماره موبایل الزامی است');
        setIsMobileValid(false);
        return false;
      }
      
      const cleaned = number.replace(/[^\d]/g, '');
      
      // Check against the regex pattern
      const regex = new RegExp(iranianMobileRegex);
      if (!regex.test(cleaned)) {
        setMobileValidationError(persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT);
        setIsMobileValid(false);
        return false;
      }
      
      setMobileValidationError(null);
      setIsMobileValid(true);
      return true;
    };

    // Validate password function
    const validatePassword = (password) => {
      if (!password || password.trim() === '') {
        setPasswordValidationError('رمز عبور الزامی است');
        setIsPasswordValid(false);
        return false;
      }
      
      // Add more password validation rules if needed
      if (password.length < 4) {
        setPasswordValidationError('رمز عبور باید حداقل ۴ کاراکتر باشد');
        setIsPasswordValid(false);
        return false;
      }
      
      setPasswordValidationError(null);
      setIsPasswordValid(true);
      return true;
    };

    // Check if form is valid
    const isFormValid = () => {
      return isMobileValid && isPasswordValid;
    };

    // 🔥 FIXED: handleSubmit without e.preventDefault()
    const handleSubmit = async () => {
      // Validate both fields before submission
      const isMobileValidNow = validateMobileNumber(formData.mobile);
      const isPasswordValidNow = validatePassword(formData.password);
      
      if (!isMobileValidNow || !isPasswordValidNow) {
        setErrorMessage('لطفاً اطلاعات را به درستی وارد کنید');
        return; // STOP - Prevent login attempt
      }
      
      setIsDisabled(true);
      
      try {
        const res = await auth.loginAction(formData);
        setIsDisabled(false);
        setErrorMessage(null);
      } catch (error) {
        setIncorrectData(true);
        setIsDisabled(false);
        if(error.response){
          console.log('error: ', error.response)
            if(error?.response?.data?.error === 'mismatch challenge'){
                window.location.reload();
            }
            else if(error?.response?.data && error?.response?.data?.non_field_errors){
                setErrorMessage(error?.response?.data?.non_field_errors[0]);
            }
            else if(error.response.status === 400){
                errorNotify(persianLanguage.phrase.error.ERROR_400);
            } else if(error.response.status === 401){
                errorNotify(persianLanguage.phrase.error.ERROR_401);
                setErrorMessage(persianLanguage.phrase.error.ERROR_401)
              } else if(error.response.status === 403){
                errorNotify(persianLanguage.phrase.error.ERROR_403);
            }else if(error.response.status === 404){
                errorNotify(persianLanguage.phrase.error.ERROR_404);
            }else if(error.response.status === 412){
                errorNotify('عدم همخوانی اطلاعات ارسالی');
            }
        }
      }
    };
        
  const handleMobileNumberChange = (e) => {
    // Clear errors when user types
    setErrorMessage(null);
    setMobileValidationError(null);
    
    if(e.event.target.value){
      const convertedNumber = convertPersianOrArabicNumbersToEnglishInTheString(e.event.target.value)
      const result = mobileNumberValidation(convertedNumber);

      if (result['status'] === 200){
        const mobileValue = result["value"];

        setMobileNumber(mobileValue);
        setFormData(prev => ({
            ...prev,
            mobile: convertPersianOrArabicNumbersToEnglishInTheString(mobileValue)
        }));    
        
        // Validate as user types
        validateMobileNumber(mobileValue);
        
        let mobileNumberArray = mobileNumbers;
        mobileNumberArray.push(result['value'])
        if (mobileNumberArray.length > 0){
          let filteredArray = removeEmptyMembersFromArray(mobileNumberArray)
          const tempUniqueArray = makeArrayUnique(filteredArray);
          setUniqueArray(tempUniqueArray)
        }
      } else {
        setIsMobileValid(false);
        setMobileValidationError('شماره موبایل نامعتبر است');
      }
    } else {
      setIsMobileValid(false);
      setMobileValidationError('شماره موبایل الزامی است');
    }    
  }

  const handleMobileItemSelection = (e) => {
    // Clear errors on selection
    setErrorMessage(null);
    setMobileValidationError(null);
    
    if(e?.itemData){
      const result = mobileNumberValidation(e.itemData);
      const mobileValue = result["value"];

      if (result['status'] === 200){
        setFormData(prev => ({
            ...prev,
            mobile: convertPersianOrArabicNumbersToEnglishInTheString(mobileValue)
        }));          
        setMobileNumber(mobileValue);
        validateMobileNumber(mobileValue);
      } else {
        setIsMobileValid(false);
        setMobileValidationError('شماره موبایل نامعتبر است');
      }
    }    
  }

  const handlePasswordChange = (e) => {
    // Clear errors when user types
    setErrorMessage(null);
    setPasswordValidationError(null);
    
    const password = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
    setFormData(prev => ({
        ...prev,
        password: password
    }));
    
    // Validate as user types
    validatePassword(password);
  };
  
  return (
    <Fragment>

    <div className="grid md:grid-cols-1 sm:grid-cols-12">
      <div className="sm:col-span-10">
      <div className="flex items-center justify-center ">
      <form action='login' 
        className="w-full max-w-md mx-auto p-4 sm:p-6 bg-white rounded-xl border border-gray-200 shadow-sm"

      onSubmit={(e) => {
        e.preventDefault(); // 🔥 Handle form submission here
        handleSubmit();
      }}>
        {/* <div className='text-center' >{persianLanguage.word.general.ENTER}</div> */}
        
        {/* Mobile Number Input */}
        {mobileNumbers.length > 0 &&
          <SelectBox
          name='mobileNumber'
          items={mobileNumbers}
          label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          labelMode='floating'
          acceptCustomValue={true}
          maxLength={11}
          defaultValue={mobileNumber}
          onItemClick={handleMobileItemSelection}
          onKeyUp={handleMobileNumberChange}
          onChange={(e) => {
            // Validate on change
            if (e.value) {
              const converted = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
              validateMobileNumber(converted);
              setFormData(prev => ({
                ...prev,
                mobile: converted
              }));
            }
          }}
          >
          </SelectBox>
        }
        {mobileNumbers.length === 0 &&
          <TextBox
          name='mobileNumber'
          label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          labelMode='floating'
          placeholder={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          valueChangeEvent="keyup"
          onKeyUp={handleMobileNumberChange}
          onChange={(e) => {
            // Validate on change
            if (e.value) {
              const converted = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
              validateMobileNumber(converted);
              setFormData(prev => ({
                ...prev,
                mobile: converted
              }));
            }
          }}
          >
          </TextBox>
        }

        {/* Mobile validation error */}
        {mobileValidationError && (
          <div className="text-red-600 text-sm mt-1 mb-2">
            {mobileValidationError}
          </div>
        )}

        {/* Password Input */}
        <TextBox
            name="password"
            mode="password"
            label={persianLanguage.word.user.PASSWORD}
            labelMode="floating"
            placeholder={persianLanguage.word.user.PASSWORD}
            valueChangeEvent="keyup"
            className='number-input-ltr'
            onValueChanged={handlePasswordChange}
            onChange={(e) => {
              // Validate on change
              if (e.value) {
                const password = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
                validatePassword(password);
                setFormData(prev => ({
                  ...prev,
                  password: password
                }));
              }
            }}
        >
            <Validator>
            <RequiredRule 
                message={persianLanguage.phrase.required.PASSWORD_REQUIRED} 
            />
            </Validator>
        </TextBox>

        {/* Password validation error */}
        {passwordValidationError && (
          <div className="text-red-600 text-sm mt-1 mb-2">
            {passwordValidationError}
          </div>
        )}

        <div>
          <Button        
            // disabled={isDisabled || !isFormValid()} // Disable if form is invalid
            disabled={false} // Disable if form is invalid
            width='100%'
            id='mobileSubmitId'
            className='flex justify-content golden-button mt-5'
            onClick={handleSubmit} // 🔥 Button onClick directly calls handleSubmit       
          >
            <div>
              {persianLanguage.word.general.ENTER}
              <SpinnerLoading isSpinning={isDisabled} />
            </div>
          </Button>
          <div className='mt-1'>
              {errorMessage && <span className=' text-red-600 px-2 mt-5 rounded'>{errorMessage}</span>}
          </div>
        </div>
      </form>
      </div>
      </div>
      <div className="md:col-span-1 sm:col-span-1"></div>
    </div>

    </Fragment>
  );    
  
}